import React, { PropTypes, Component } from 'react';
import Moment from 'moment';
import { findDOMNode } from 'react-dom';
import Blazy from 'blazy';
import Classes from './gridhelper/generatePostClassesWithTerms';
const $ = jQuery;

class DoPostStandard extends Component {
  constructor(props) {
    super(props);
    this.hideLoadingGig = this.hideLoadingGig.bind(this);
    this.state = {
      isotope: false,
    };
  }
  componentDidMount() {
    this.showPopup(this.props);
    const bLazy = new Blazy({
      success: this.hideLoadingGig,
      error: function(ele, msg) {
        // error function
      },
    });
  }
  componentWillReceiveProps(nextProps) {
    const bLazy = new Blazy({
      success: this.hideLoadingGig,
      error: function(ele, msg) {
        // error function
      },
    });    
  }
  componentWillMount() {
    const post = this.props.post;
    this.termAsClasses = Classes.generatePostClassesWithTerms(post.terms);
    this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
  }
  hideLoadingGig(ele) {
    const id = this.props.post.ID;
     $('.dummyClass' + id).removeClass('lazyLoading');
  }
  componentDidUpdate() {
    this.showPopup(this.props);
  }

  showPopup(props) {
    const self = this;
    const post = props.post;

    jQuery(document).ready(() => {
      jQuery('.parent-container').magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
          enabled: false,
        },
      });
      jQuery('.parent-gallery-container').magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
          enabled: true,
        },
      });
      if (post.post_format === 'standard') {
        jQuery('.parent-container').magnificPopup({
          delegate: 'a',
          type: 'image',
          gallery: {
            enabled: false,
          },
        });
      }
      if (post.post_format === 'gallery') {
        jQuery('.parent-gallery-container').magnificPopup({
          delegate: 'a',
          type: 'image',
          gallery: {
            enabled: true,
          },
        });
      }
      if (post.post_format === 'video') {
        jQuery('.open-popup').magnificPopup({
          type: 'iframe',
        });
      }
      if (post.post_format === 'audio') {
        jQuery('.open-audio').magnificPopup({
          type: 'iframe',
        });
      }
    });
  }
  handleClick(e) {
    e.preventDefault();
  }
  render() {
    const { post, view } = this.props;
    const thumbAlt = post.thumb_alt !== undefined ? post.thumb_alt : '';
    let termAsClasses = this.termAsClasses;
    termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
    let imgStyle = null;
    if ( this.state.isotope === false ) {
      imgStyle = {
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        position: 'relative',
        width: '100%',
        height: '100%',
      };
    } else {
      imgStyle = {
        backgroundImage: 'url(' + post.thumb_url + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        position: 'relative',
        width: '100%',
        height: '100%',
      };        
    }
    return (<div>
      { view === 'grid' ? <div>
        <div className="rq-image-grid">
          <div className="rq-grid-normal full-width-bg-image no-border-radius top-heading">
             <div className="post-image-container">
                {post.thumb_url && post.post_format === 'standard' ?
                  <div className={ this.state.isotope === false ? 'image-hover-coantainer lazyLoading b-lazy dummyClass' + post.ID : 'image-hover-coantainer'} style={imgStyle} data-src={this.state.isotope === false ? post.thumb_url : null}>
                    <div className="img-overlay parent-container">
                      <a className="rq-gallery-popup-link" href={post.thumb_url}>
                        <i className="ion-android-add">
                        </i>
                        <img src={post.thumb_url} alt={thumbAlt}/>
                      </a>
                    </div>
                  </div>
                : ''}
                {post.meta.post_video !== undefined && post.post_format === 'video' ?
                  <a className="open-popup rq-post-standard" href={post.meta.post_video}>
                    <img src={API.IMG + 'placeholder-video.jpg'} />
                  </a> : ''}
                {post.meta.post_sound !== undefined && post.post_format === 'audio' ?
                  <a className="open-audio rq-post-standard" href={post.meta.post_sound}>
                    <img src={API.IMG + 'placeholder-audio.jpg'} />
                  </a> : ''}
              <div className="rq-img-post-title-content">
                <h2><a href={post.post_link}>{post.post_title}</a></h2>
                <span className="post-date">{ Moment(post.post_date).format('ll') }</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      :
      <div className="flex-row">
        <div className="flex-md-12 flex-sm-12 flex-xs-12">
          <div className="rq-image-grid">
            <div className="rq-grid-normal with-left-image">
              <div className="flex-row">
                <div className={ this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list'} style={imgStyle} data-src={this.state.isotope === false ? post.thumb_url : null}>
                  <div className="img-overlay parent-container">
                    <a className="rq-gallery-popup-link" href={post.thumb_url}>
                      <i className="ion-android-add"></i>
                      <img src={post.thumb_url} alt={thumbAlt}/>
                    </a>
                  </div>
                </div>
                <div className="flex-md-7 flex-sm-12 flex-xs-12">
                  <div className="post-content">
                    <h2><a href={post.post_link}>{post.post_title}</a></h2>
                    <span className="post-date">{ Moment(post.post_date).format('ll') }</span>
                    <div className={'post-text' + termAsClasses} dangerouslySetInnerHTML={{ __html: post.post_excerpt.slice(0, 70) + '...' }}></div>
                    <a href={post.post_link} className="btn btn-blog">{API.LANG.MORE}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    </div>);
  }
}

ReactiveTemplates['doPostStandard'] = DoPostStandard;

ReactiveLayouts.push({
  'key': 'doPostStandard',
  'image_url': API.IMG + 'do-post-grid.jpg',
  'type': 'all',
  'format': 'standard',
  'gridName': 'CoverGrid',
});


// WEBPACK FOOTER //
// ./assets/src/frontend/preview/block/layout/grid/coverGrid.js